import createSagaMiddleware from 'redux-saga'
import { legacy_createStore as createStore, applyMiddleware } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import { composeWithDevTools } from 'redux-devtools-extension'
import storage from 'redux-persist/lib/storage'

import rootReducer from './Reducers'
import sagas from './Sagas'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)
const sagaMiddleware = createSagaMiddleware()
const composeEnhancers = composeWithDevTools({ trace: true })

export default () => {
  const enhancer = composeEnhancers(applyMiddleware(sagaMiddleware))
  // TODO: createStore has been deprecated in latest redux update
  // they recommend using configureStore instead
  // to still use createStore(), we will for now use legacy_createStore
  const store = createStore(persistedReducer, {}, enhancer)
  const persistor = persistStore(store)

  sagaMiddleware.run(sagas)

  return { store, persistor }
}
